export const environment = {
  production: false,
  showMissingDeeds: true,
  showQuery: true,
  showTickets: true,
  showOwnerCategorySelection: true,
  server: 'https://api-gateway.dev.dokuma.co.zw/deeds/',
  farms: 'https://land-tenure-api.dev.dokuma.co.zw/farms/',
  applicationUrl: 'http://localhost:4200/',
  googleClientId: '98860499288-ui7glnqbbls2tqmcenmgh7ndeb7s2rcm.apps.googleusercontent.com',
  googleRedirectUri: 'https://econveyancer.dev.dokuma.co.zw/',
  iveriReturnUrl: 'https://api-gateway.dev.dokuma.co.zw/deeds/public/payment/authenticate',
  paymentRedirectUrl: 'https://payment.dev.dokuma.co.zw/status/',
  econveyancerUrl: 'https://econveyancer.dev.dokuma.co.zw/auth/login',
  externalTicketingEnabled: true,
  externalTicketingSystemName: 'JIRA',
  externalTicketingProjectKey: 'SUP',
  externalTicketingBrowseUrl: 'https://jira.example.com/browse/'
};
